import { useNavigate, useSearchParams } from 'react-router';
import { memo, useEffect, useMemo } from 'react';
import classNames from 'classnames';
import { useFullScreen } from 'src/hooks/useFullScreen';
import { useGameModals } from './hooks/useGameModals';
import {
  useGameFrameAutoResize,
  useBoolean,
  useWindowSize,
  useGetFreeSpins
} from 'react-easyrocket';
import { Header } from './components/GameHeader';
import { useDrawer } from 'src/hooks/useDrawer';
import { useGetGameData } from './hooks/useGetGameData';
import './styles.css';
import { MODAL_SEARCH } from 'src/components/Modal/SearchModal/constants';
import { useModalContext } from 'src/hooks/useModalContext';
import { useRoute } from 'src/router/hooks';
import { ErrorGamePage } from './components/ErrorGamePage';
import { AxiosResponse } from 'axios';
import { THREE_SECONDS } from 'src/constants';
import { GameFrame } from './components/GameFrame';

const GamePage = () => {
  const navigate = useNavigate();
  const { ROUTE } = useRoute();
  const [headerVisible, openHeader, closeHeader, toggleHeader] = useBoolean(true);
  const { isFullscreen, onFullscreenOpen, onFullscreenClose } = useFullScreen();
  const { isLeftDrawerOpen } = useDrawer();
  const [searchParams] = useSearchParams();
  const jackpotType = searchParams.get('jackpot') as string | undefined;
  const { is768 } = useWindowSize();
  const { openModal } = useModalContext();

  const { game, error } = useGetGameData();
  useGameModals(game);
  // useEvolutionModal(game?.providerId);

  const handleFullscreenOpen = () => {
    onFullscreenOpen();
    closeHeader();
  };
  const isShowModal = Boolean(sessionStorage.getItem(MODAL_SEARCH));

  const gameFreeSpins = game?.freeSpins;
  const { freeSpins } = useGetFreeSpins({ refetchInterval: THREE_SECONDS });

  const userFreeSpins = useMemo(() => {
    if (!gameFreeSpins || !freeSpins || freeSpins.number === 0) return undefined;
    if (freeSpins.number > 0 && freeSpins.dayLimit > 0 && freeSpins.numberDay > 0)
      return freeSpins.numberDay;
    if (freeSpins.number > 0 && freeSpins.dayLimit > 0 && freeSpins.numberDay === 0)
      return undefined;
    if (freeSpins.number > 0 && freeSpins.dayLimit === 0) return freeSpins.number;
  }, [freeSpins, gameFreeSpins]);
  const headerHeight = () => {
    if (userFreeSpins) {
      if (is768) {
        return 110;
      }

      return 80;
    }

    return 60;
  };

  const { gameFrameStyle, headerRef } = useGameFrameAutoResize({
    isHeaderVisible: headerVisible,
    headerHeight: headerHeight()
  });

  useEffect(() => {
    return () => {
      if (isShowModal && !is768) {
        navigate(ROUTE.MAIN.get());
        openModal('SEARCH', { props: { searchTab: 'games' } });
        sessionStorage.removeItem(MODAL_SEARCH);
      }
    };
  }, []);

  useEffect(() => {
    if (!isFullscreen) {
      openHeader();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFullscreen]);

  useEffect(() => {
    return () => {
      onFullscreenClose?.();
    };
    // выход из фулскрина при выходе из игры
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={classNames('overflow-hidden', isLeftDrawerOpen && 'brightness-50 blur-[5px]')}>
      <Header
        headerRef={headerRef}
        headerVisible={headerVisible}
        toggleHeader={toggleHeader}
        jackpotType={jackpotType}
        isFullscreen={isFullscreen}
        onFullscreenOpen={handleFullscreenOpen}
        onFullscreenClose={onFullscreenClose}
        game={game}
      />
      {error ? (
        <ErrorGamePage errorMessage={(error?.response as AxiosResponse)?.data?.message} />
      ) : (
        <GameFrame gameUrl={game?.gameUrl} isFullscreen={isFullscreen} style={gameFrameStyle} />
      )}
    </div>
  );
};

export default memo(GamePage);
